// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--1Op28","logo":"Header-module--logo--3yAKW","nav":"Header-module--nav--10wjH"};